"use client";
import Image from "next/image";
import Link from "next/link";
import MobileMenu from "./MobileMenu";

import logo_1 from "@/assets/img/logo/logo.png";
import { useSession } from "@/component/SessionProvider";
import { usePathname } from "next/navigation";

const Sidebar = ({ isActive, setIsActive }: any) => {
  const { session } = useSession();
  const closeSidebar = () => {
    setIsActive(false);
  };

  const path = usePathname();
  const isHome = path === "/";

  return (
    <div className={` ${isActive ? "mobile-menu-visible" : ""}`}>
      <div className="mobile-menu">
        <nav className="menu-box">
          <div onClick={() => setIsActive(false)} className="close-btn">
            <i className="fas fa-times"></i>
          </div>
          <div className="nav-logo">
            <Link href="/">
              <Image src={logo_1} alt="Logo" />
            </Link>
          </div>
          <div className="menu-outer">
            <MobileMenu setIsActive={setIsActive} />
          </div>
          {!session.isAuthenticated ? (
            <div className="p-2">
              <Link
                className="btn hover:bg-appPrimary"
                onClick={closeSidebar}
                href="/login"
              >
                LOGIN
              </Link>
            </div>
          ) : (
            <div className="p-2">
              {isHome && (
                <Link
                  className="btn hover:bg-appPrimary"
                  onClick={closeSidebar}
                  href="/dashboard"
                >
                  Dashboard
                </Link>
              )}
            </div>
          )}

          {/* <div className="social-links">
            <ul className="clearfix list-wrap">
              <li>
                <a href="#">
                  <i className="fab fa-facebook-f"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fab fa-twitter"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fab fa-instagram"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </li>
              <li>
                <a href="#">
                  <i className="fab fa-youtube"></i>
                </a>
              </li>
            </ul>
          </div> */}
        </nav>
      </div>
      <div onClick={() => setIsActive(false)} className="menu-backdrop"></div>
    </div>
  );
};

export default Sidebar;
